import { render } from "./FiltersSelected.vue?vue&type=template&id=a960aca4"
import script from "./FiltersSelected.vue?vue&type=script&lang=js"
export * from "./FiltersSelected.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__